import * as LazyComponents from '../../frontends/ProviderSearch/routes/PSXHome/lazyComponents';
import { useCurrentMember } from '../../hooks/useCurrentMember';
import { CareCategories, LOB } from '../Constants';

export type Props = {
  selectedChipValue: string;
};

export const DisclaimerContent = ({ selectedChipValue }: Props) => {
  const { lineOfBusiness = '' } = useCurrentMember();

  const getDisclaimer = (selectValue) => {
    switch (selectValue) {
      case CareCategories.VIRTUAL_VISIT:
        return <LazyComponents.DisclaimersContainer isVirtualVisit />;
      case CareCategories.PRIMARY_CARE:
      case CareCategories.MEDICAL_SPECIALISTS:
      case CareCategories.BEHAVIORAL_HEALTH:
      case CareCategories.DENTAL:
        return <LazyComponents.DisclaimersContainer />;
      case CareCategories.VISION:
        return <LazyComponents.DisclaimersContainer isVisionCare />;
      default:
        return null;
    }
  };

  switch (lineOfBusiness) {
    case LOB.MNR:
      return <LazyComponents.DisclaimersContainer isLandingPage />;
    case LOB.CNS:
      return <LazyComponents.DisclaimersContainer />;
    default:
      return getDisclaimer(selectedChipValue);
  }
};
